import React from 'react';
import { Disclosure as HLDisclosure, Transition } from '@headlessui/react';
import useDisclosureContext from './useDisclosureContext';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function DisclosurePanel(props: Props) {
  const { children } = props;
  const { open } = useDisclosureContext();
  return (
    <div>
      {/*@ts-ignore */}
      <Transition
        show={!!open}
        enter="disclosureEnter"
        enterFrom="disclosureEnterFrom"
        enterTo="disclosureEnterTo"
        leave="disclosureLeave"
        leaveFrom="disclosureLeaveFrom"
        leaveTo="disclosureLeaveTo"
      >
        <HLDisclosure.Panel className={props.className} static>
          {children}
        </HLDisclosure.Panel>
      </Transition>
    </div>
  );
}
